import AnalysisResult from './AnalysisResult';

export default (props) => {
  return <AnalysisResult {...props} />;
};
